<section class="complete-signup">
  <h1>{{ "FINALIZE_SIGNUP_TITLE" | translate }}</h1>
  <p>{{ "FINALIZE_SIGNUP_INTRO" | translate }}</p>

  <form [formGroup]="legalForm" (ngSubmit)="onSubmit()" class="mb-0!">
    <app-legal-acceptance-controls
      [form]="legalForm"
    ></app-legal-acceptance-controls>

    @if (error) {
    <div class="error">
      {{ error.error.error | translate }}
    </div>
    }

    <button type="submit" class="complete-submit" [disabled]="submitDisabled">
      {{ submitButtonText }}
    </button>
  </form>
</section>
